import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	emptyStateHeader: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	emptyStateDescription: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	emptyStateDescriptionForMobile: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	viewAllProjects: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	loadMore: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	emptyStateDescriptionGalaxia: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	viewAllProjectsGalaxia: {
		defaultMessage: string;
		id: string;
		description: string;
	};
} = defineMessages({
	emptyStateHeader: {
		defaultMessage: 'You haven’t viewed any item recently',
		id: 'home.tabs.recently-viewed.empty-state-header',
		description: 'Empty State header for jira home viewed tab',
	},
	emptyStateDescription: {
		defaultMessage:
			'In this page, you’ll find a list of your recently viewed items. Get started by finding the project your team is working on.',
		id: 'home.tabs.recently-viewed.empty-state-description',
		description: 'Empty State description for jira home viewed tab',
	},
	emptyStateDescriptionForMobile: {
		defaultMessage: 'On this page, you’ll find a list of your recently viewed items.',
		id: 'home.tabs.recently-viewed.empty-state-description-for-mobile',
		description: 'Empty State description for jira home viewed tab on mobile',
	},
	viewAllProjects: {
		defaultMessage: 'View all projects',
		id: 'home.tabs.recently-viewed.view-all-projects',
		description:
			'The message show in the button on the empty state of the Recently Viewed tab on Jira Home.',
	},
	loadMore: {
		defaultMessage: 'Load more',
		id: 'home.tabs.recently-viewed.load-more',
		description: 'A label for a button that will load more issues when clicked',
	},

	emptyStateDescriptionGalaxia: {
		defaultMessage:
			'In this page, you’ll find a list of your recently viewed work items. Get started by finding the space your team is working on.',
		id: 'home.tabs.recently-viewed.empty-state-description-galaxia',
		description: 'Empty State description for jira home viewed tab',
	},
	viewAllProjectsGalaxia: {
		defaultMessage: 'View all spaces',
		id: 'home.tabs.recently-viewed.view-all-projects-galaxia',
		description:
			'The message show in the button on the empty state of the Recently Viewed tab on Jira Home.',
	},
});
export default messages;
